
import { useState } from "react";

function MyForm() {
    
    
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const [reason, setreason] = useState('');
    const [organization, setorganization] = useState('');
    const [mail, setmail] = useState('');
    
    

    const handleSubmit = (event) => {
        event.preventDefault();
        const emailBody = `Name: ${name}\nReason: ${reason}\nOrganization: ${organization}\nEmail: ${mail}\nMessage: ${message}`;
        window.location.href = `mailto:stbouch@hotmail.com?subject=Contact Form Submission&body=${encodeURIComponent(emailBody)}`;
      }


  return(
        


        <form style = {{marginTop: "10%", marginBottom: "10%"}} onSubmit={handleSubmit}>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="inputName">Ονοματεπώνυμο</label>
                    <input type="text" className="form-control" id="inputName" placeholder="Ονοματεπώνυμο" value={name}
                    onChange={(event) => setName(event.target.value)}/>
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="ReasonForData">Προσδιορίστε το λόγο που επιθυμείτε να έχετε πρόσβαση στα δεδομένα</label>
                    <input type="text" className="form-control" id="ReasonForData" placeholder="Γράψε" value={reason}
                    onChange={(event) => setreason(event.target.value)}/>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="Organization">Οργανισμός/Φορέας</label>
                    <input type="text" className="form-control" id="Organization" placeholder="Γράψε" value={organization}
                    onChange={(event) => setorganization(event.target.value)}/>
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="inputEmail">Λογαριασμός ηλεκτρονικού ταχυδρομείου</label>
                    <input type="email" className="form-control" id="inputEmail" placeholder="Γράψε"value={mail}
                    onChange={(event) => setmail(event.target.value)}/>
                </div>
            </div>

            <div className="form-group">
                <label htmlFor="exampleFormControlTextarea">Σχόλια προς τους διαχειριστές</label>
                <textarea className="form-control" id="exampleFormControlTextarea" rows="3" value={message}
                onChange={(event) => setMessage(event.target.value)}></textarea>
            </div>

            
            <button type="submit" className="btn btn-primary">Υποβολή</button>
        </form>
        
  );
}

export default MyForm;
